<template>
  <modal size="modal-xl" @close="$emit('close')">
    <template v-slot:title>
      Recebedores da Instituição
    </template>

    <template v-slot:body>
      <table
        v-if="true"
        class="table table-condensed table-bordered"
      >
        <colgroup>
          <col class="col-md-3">
          <col class="col-md-3">
          <col class="col-md-2">
          <col class="col-md-1">
          <col class="col-md-1">
          <col class="col-md-2">
          <col class="col-md-1">
        </colgroup>
        <thead>
          <tr>
            <th class="table-centralized">
              Nome
            </th>
            <th class="table-centralized">
              Documento
            </th>
            <th class="table-centralized">
              Tipo
            </th>
            <th class="table-centralized">
              Banco
            </th>
            <th class="table-centralized">
              Agência
            </th>
            <th class="table-centralized">
              Conta
            </th>
            <th class="table-centralized">
              Ação
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="recipients.length === 0">
            <td colspan="7" class="table-centralized">
              Não existem recebedores para está instituição.
            </td>
          </tr>
          <tr v-for="recipient in recipients">
            <td>
              {{ recipient.name }}
            </td>
            <td>
              {{ recipient.document_type.toUpperCase() }}: {{ recipient.document_formatted }}
            </td>
            <td>
              {{ recipient.bank_account.translated_bank_account_type }}
            </td>
            <td>
              {{ recipient.bank_account.bank_code }}
            </td>
            <td>
              {{ agency(recipient.bank_account) }}
            </td>
            <td>
              {{ account(recipient.bank_account) }}
            </td>
            <td>
              <a href="#" @click.prevent="selectedRecipient(recipient)">
                Selecionar
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <template v-slot:footer>
      <button class="btn btn-default" @click="$emit('close')">
        Fechar
      </button>
    </template>
  </modal>
</template>
<script>
import { mapState } from 'vuex';
import Modal from 'components/Modal';
import { toCamelCase } from 'utils';

export default {
  components: {
    Modal,
  },
  computed: {
    ...mapState([
      'institution',
      'recipients',
    ]),
  },
  methods: {
    account(bankAccount) {
      if (bankAccount.digit) return `${bankAccount.number}-${bankAccount.digit}`;

      return bankAccount.number;
    },
    agency(bankAccount) {
      if (bankAccount.agency_digit) return `${bankAccount.agency_code}-${bankAccount.agency_digit}`;

      return bankAccount.agency_code;
    },
    selectedRecipient(recipient) {
      const selectedRecipient = {
        ...toCamelCase(recipient),
        bankAccount: toCamelCase(recipient.bank_account),
      };
      this.$emit('selected-recipient', selectedRecipient);
    },
  },
};
</script>
